
import React, { useEffect } from 'react';
import {  Layout } from 'antd';
import Navbar from './Navbar';
import AppFooter from '@/containers/AppFooter.jsx'

const UserLayout = ({ 
  children, 
}) => {
  
  // 
  return <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Navbar />

      {children}
      
      <AppFooter/>
    </Layout>
};

export default UserLayout;